<i class="k-icon k-font-icon k-i-close dialog-close" (click)="onClose()"></i>
<div class="container-fluid">
  <div class="row">
    <div class="container">
      <div class="dialog-title">Export Options</div>
      <div>Please select the sections you want included in your export.</div>

      <kendo-treeview
        class="pt-2"
        [nodes]="data"
        textField="text"
        kendoTreeViewHierarchyBinding
        childrenField="items"
        kendoTreeViewCheckable
        [(checkedKeys)]="checkedKeys"
      >
      </kendo-treeview>

      <button
        themeColor="primary"
        class="dialog-button"
        (click)="onSubmit()"
        kendoButton
        [disabled]="checkedKeys.length == 0"
      >
        Export
      </button>
    </div>
  </div>
</div>
